import { checkOption } from '@/api/trade-capture/option/checkOption.ts';
import { createStrip } from '@/api/trade-capture/option/createStrip.ts';
import { webapi } from '@/api/webapi.ts';

export const tradeCaptureApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    checkOption: checkOption(builder),
    createStrip: createStrip(builder),
  }),
});

export const { useCheckOptionMutation, useCreateStripMutation } = tradeCaptureApi;
